export function isPartOfGroup(groups, type) {
    if (!groups)
        return false;
    return Boolean(groups?.some(group => group.type === type));
}
//# sourceMappingURL=users.js.map